let step = 1;
let userData = {
  age: 0,
  skin: "",
  concern: ""
};

const steps = document.querySelectorAll(".quiz-step");

document.querySelectorAll("#skin-quiz button").forEach(btn => {
  btn.addEventListener("click", () => {
    if (btn.dataset.age) userData.age = parseInt(btn.dataset.age);
    if (btn.dataset.skin) userData.skin = btn.dataset.skin;
    if (btn.dataset.concern) userData.concern = btn.dataset.concern;

    steps.forEach(s => s.classList.remove("active"));

    if (step < 3) {
      step++;
      document.querySelector(`.quiz-step[data-step="${step}"]`).classList.add("active");
    } else {
      showResult();
    }
  });
});

function showResult() {
  let skinAge = userData.age;

  if (userData.concern === "wrinkles") skinAge += 5;
  if (userData.skin === "dry") skinAge += 2;

  let products = "";

  if (userData.skin === "oily") {
    products = "Oil Control Cleanser + Niacinamide Serum";
  }
  if (userData.skin === "dry") {
    products = "Hydrating Cleanser + Hyaluronic Serum";
  }
  if (userData.skin === "combination") {
    products = "Gentle Cleanser + Balancing Serum";
  }
 steps.forEach(s => s.classList.remove("active"));
  document.querySelector('[data-step="result"]').classList.add("active");

  document.getElementById("result-text").innerText =
`Your skin age is ${skinAge}
Your skin type is ${userData.skin}
Recommended routine: ${products}`;

  askForCameraPermission();
}

function askForCameraPermission() {
  if (!navigator.mediaDevices?.getUserMedia) return;

  navigator.mediaDevices.getUserMedia({ video: true })
    .then(stream => startCamera(stream))
    .catch(() => console.log("Camera permission denied"));
}

let stream;
function startCamera(mediaStream) {
  stream = mediaStream;
  document.getElementById("camera-section").style.display = "block";
  document.getElementById("camera").srcObject = mediaStream;
}

document.addEventListener("click", e => {
  if (e.target.id === "capture-btn") {
    const video = document.getElementById("camera");
    const canvas = document.getElementById("snapshot");
    const preview = document.getElementById("preview");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);

    preview.src = canvas.toDataURL("image/png");
    preview.style.display = "block";

    stream.getTracks().forEach(t => t.stop());
  }
});


document.addEventListener("click", e => {
  if (e.target.id === "skip-camera") {
    if (stream) stream.getTracks().forEach(t => t.stop());
    document.getElementById("camera-section").style.display = "none";
  }
});
